import type { FaireProductEntity } from "@faire/playground-entity-db/entity_types/product";

import { FavoriteProductTile } from "./FavoriteProductTile";
import type { BrandCart } from "./useBrandCart";
import type { FavoritesController } from "./useFavoritesController";

interface SavedProductTileProps {
  product: FaireProductEntity;
  favorites: FavoritesController;
  cart: BrandCart;
}

/** Heart-enabled product tile with quick-add wired to the brand cart. */
export const SavedProductTile = ({
  product,
  favorites,
  cart,
}: SavedProductTileProps) => {
  const quantity = cart.cartQuantityFor(product.token);
  return (
    <FavoriteProductTile
      product={product}
      isFavorited={favorites.isSaved(product.token)}
      onFavorite={favorites.handleFavoriteClick}
      savedHeartFill="red"
      showQuickAdd
      quickAddQuantity={quantity}
      onQuickAdd={() => cart.handleQuickAdd(product)}
      onQuickAddIncrement={() => cart.handleQuickAddIncrement(product, quantity)}
      onQuickAddDecrement={() => cart.handleQuickAddDecrement(product, quantity)}
    />
  );
};
